const DISCOUNT_MODAL_SHOWN_KEY = 'dutchie_discount_modal_shown';

type DiscountId = number | string;

/** Get discount IDs that have already shown their modal in this browser session. */
export const getShownDiscountIds = (): Set<string> => {
  try {
    const stored = sessionStorage.getItem(DISCOUNT_MODAL_SHOWN_KEY);
    // This module is the sole writer and always serializes a Set<string>. Supplying the
    // generic at the JSON boundary adds no cast/coercion and preserves JSON.parse/new Set's
    // exact runtime behavior for externally-corrupted values (the catch below still recovers).
    return stored ? new Set<string>(JSON.parse(stored)) : new Set<string>();
  } catch {
    return new Set<string>();
  }
};

/** Mark a discount as having shown its modal in this browser session. */
export const markDiscountAsShown = (discountId: DiscountId): void => {
  try {
    const shown = getShownDiscountIds();
    shown.add(String(discountId));
    sessionStorage.setItem(DISCOUNT_MODAL_SHOWN_KEY, JSON.stringify([...shown]));
  } catch {
    // Silently fail if sessionStorage is unavailable.
  }
};

/** Check whether a discount modal has already been shown. */
export const hasDiscountBeenShown = (discountId: DiscountId): boolean => getShownDiscountIds().has(String(discountId));

/** Clear all shown discount IDs (useful for tests and session resets). */
export const clearShownDiscountIds = (): void => {
  try {
    sessionStorage.removeItem(DISCOUNT_MODAL_SHOWN_KEY);
  } catch {
    // Silently fail if sessionStorage is unavailable.
  }
};
